// extracted by mini-css-extract-plugin
export default {"container":"CompanySelectorPage_container__tDLK+","content":"CompanySelectorPage_content__cp2QU"};